const hotels = {
  name: 'Hotel |||| Hotels',
  fields: {
    name: 'Name',
    hotelChainName: 'Chain',
    hotelCategoryName: 'Category',
    address: 'Address',
    city: 'City',
    region: 'Region / Province',
    country: 'Country',
    latitude: 'Latitude',
    longitude: 'Longitude',
    pmsSystemName: 'PMS',
    lockSystemName: 'Lock system',
    paymentProcessorName: 'Payment processor',
    leadCount: 'Leads',
    notes: 'Notes',
  },
  empty: 'No hotels found',
  invite: 'Create your first hotel',
};

export default hotels;
